<template>
  <v-dialog v-model="dialog" persistent scrollable width="600">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Thay đổi trạng thái & Hạn đăng ký
        <v-spacer />
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div class="mb-3 text-body-1 black--text">Thông tin hồ sơ</div>
        <div class="mb-1">
          Mã hồ sơ: <strong>{{ $get(item, 'code') }}</strong>
        </div>
        <div class="mb-1">
          Tên thí sinh: <strong>{{ $get(item, 'name') }}</strong>
        </div>
        <div class="mb-1">
          Trạng thái hiện tại: <strong>{{ $get(item, 'enrollmentFlag') | getEnrollmentFlagTitle }}</strong>
        </div>
        <div class="mb-1">
          Cập nhật lần cuối: <strong>{{ $get(item, 'enrollmentFlagUpdatedAt') | ddmmyyyyhhmm }}</strong>
        </div>
        <div class="mb-1">
          Người cập nhật: <strong>{{ $get(item, 'enrollmentFlagUpdatedBy.name', '') }}</strong>
        </div>
        <v-divider class="my-3" />
        <div class="mb-3 text-body-1 black--text">
          1. Cập nhật "Trạng thái"
          <span class="text-uppercase text-caption red--text font-weight-medium">(Bắt buộc)</span>
        </div>
        <v-autocomplete
          v-model="enrollmentFlag"
          :items="[
            {t: 'Nhập học', v: 'enroll'},
            {t: 'Dự khuyết', v: 'reserve'},
            {t: 'Đóng', v: 'closed'},
          ]"
          placeholder="T.thái cho phép"
          clearable
          flat
          outlined
          dense
          hide-details
          item-text="t"
          item-value="v"
        />
        <div class="mt-3 mb-1 text-body-1 black--text">
          2. Cập nhật "Hạn đăng ký" <span class="text-uppercase text-caption font-weight-medium">(Không bắt buộc)</span>
        </div>
        <div class="text-body-2 font-italic mb-3">
          Cấu hình "Hạn đăng ký" dành riêng cho hồ sơ này, mọi ràng buộc liên quan sẽ được ưu tiên xét trên "Hạn đăng
          ký" này thay vì <strong>"Hạn đăng ký Chung"</strong>.
          <br />
        </div>
        <v-checkbox v-model="hasDeadline" label="Cấu hình 'Hạn đăng ký'" dense hide-details />
        <div v-show="hasDeadline">
          <DateTimeInput :value="deadline" ref="dateTimeInput" />
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="closeDialog">Huỷ</v-btn>
        <v-btn color="admin" class="white--text" @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment'
import {get} from 'lodash'
import DateTimeInput from './deadline-config/DateTimeInput.vue'
import {mapActions} from 'vuex'
export default {
  components: {DateTimeInput},
  data: () => ({dialog: false, item: {}, enrollmentFlag: '', deadline: '', hasDeadline: false}),
  methods: {
    ...mapActions({grantEnrollmentPermSingle: 'cv/grantEnrollmentPermSingle'}),
    openDialog(item = {}) {
      const enrollDeadline = get(item, 'enrollDeadline', '')
      this.item = item
      this.enrollmentFlag = get(item, 'enrollmentFlag', '')
      this.deadline = enrollDeadline
      this.hasDeadline = typeof enrollDeadline === 'string' && enrollDeadline.length > 0
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    validate() {
      const result = {err: '', data: {}}
      const enrollmentFlag = this.enrollmentFlag
      if (typeof enrollmentFlag === 'string' && enrollmentFlag.length) result.data['enrollmentFlag'] = enrollmentFlag
      else result.err = 'Vui lòng chọn "Trạng thái"'
      if (this.hasDeadline) {
        const deadline = this.$refs['dateTimeInput'].getData()
        if (typeof deadline === 'string' && deadline.length) result.data['deadline'] = deadline
        else result.err = 'Vui lòng nhập đầy đủ ngày giờ cho "Hạn đăng ký"'
      }
      return result
    },
    async onSubmit() {
      const validData = this.validate()
      if (validData.err.length) return this.$alert.error(validData.err)
      try {
        this.$loading.active = true
        await this.grantEnrollmentPermSingle({
          id: this.item.id,
          enrollmentFlag: validData.data.enrollmentFlag,
          deadline: validData.data.deadline,
        })
        this.$emit('onRefresh')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
  filters: {
    ddmmyyyyhhmm: v => (!v ? '' : moment(v).format('DD/MM/YYYY HH:mm')),
    getEnrollmentFlagTitle: v => {
      switch (v) {
        case 'enroll':
          return 'Nhập học'
        case 'reserve':
          return 'Dự khuyết'
        default:
          return 'Đóng'
      }
    },
  },
}
</script>